module.exports = __webpack_public_path__ + "static/img/icons_packages_binding.d717fff.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/menu-icons/icons_packages_binding.svg
// module id = qVAv
// module chunks = 1